import { createUseStyles } from 'react-jss';
import { base } from '../../../../styles';

export const userOverviewStyles = createUseStyles({
  container: {
    marginBottom: base(2),
  },
});
